/** Display label for users that were removed or cannot be resolved (no raw UUIDs). */
export const UNKNOWN_USER_REMOVED = "Unknown user (removed)";

/**
 * Build a Map for resolving escalated_to / member ids → display row.
 * Keys: user id, email, user_account (and lowercased email/account where useful).
 */
export function buildUserLookupFromLists(...lists) {
  const map = new Map();
  const add = (u) => {
    if (!u || typeof u !== "object") return;
    const row = {
      name: u.name || u.full_name || u.email || u.user_account || "",
      full_name: u.full_name,
      email: u.email || "",
      user_account: u.user_account || u.email || "",
      id: u.id,
    };
    if (u.id) map.set(String(u.id), row);
    if (u.email) {
      map.set(String(u.email), row);
      map.set(String(u.email).toLowerCase(), row);
    }
    if (u.user_account) {
      map.set(String(u.user_account), row);
      map.set(String(u.user_account).toLowerCase(), row);
    }
  };
  lists.forEach((list) => (Array.isArray(list) ? list : []).forEach(add));
  return map;
}

export function resolveUserLabel(value, lookup) {
  if (value == null || value === "") return UNKNOWN_USER_REMOVED;
  const s = String(value).trim();
  if (!s) return UNKNOWN_USER_REMOVED;
  const row = lookup.get(s) || lookup.get(s.toLowerCase());
  if (row && (row.name || row.email || row.user_account)) {
    return row.name || row.email || row.user_account || UNKNOWN_USER_REMOVED;
  }
  return UNKNOWN_USER_REMOVED;
}

export function formatEscalatedToDisplay(escalatedTo, lookup) {
  if (escalatedTo == null || escalatedTo === "") return UNKNOWN_USER_REMOVED;
  const arr = Array.isArray(escalatedTo) ? escalatedTo : [escalatedTo];
  return arr.map((v) => resolveUserLabel(v, lookup)).join(", ");
}
